

































import { defineComponent, PropType } from "@vue/composition-api";
import { FeatureCardText, ImgSource } from "@/views/PageLanding/types";
import LandingButton from "../LandingButton";

export default defineComponent({
  name: "FeatureCard",
  components: { LandingButton },
  props: {
    image: { type: Object as PropType<ImgSource>, required: true },
    cardText: { type: Object as PropType<FeatureCardText>, required: true },
  },
});
